const ServedClientsBody = () => {
  return (
    <section>
      <div>
        
      </div>
    </section>
  );
};

export default ServedClientsBody;
